function windowHeight() {
  var windowHeight = window.innerHeight;
  return windowHeight;
}
function headerHeight() {
  if (document.body.contains(document.querySelector('[data-site-header]'))) {
    const headerHeight =
      document.querySelector('[data-site-header]').offsetHeight;
    //console.log(headerHeight);
    return headerHeight;
  } else {
    return;
  }
}
function cartFooter() {
  const cartFooterHeight =
    document.querySelector('.drawer__footer').offsetHeight;
  return cartFooterHeight;
}
function announcementHeight() {
  if (document.body.contains(document.querySelector('.announcement-bar'))) {
    const announcementHeight =
      document.querySelector('.announcement-bar').offsetHeight;
    if (announcementHeight == 0) {
      return 36;
    } else {
      return announcementHeight;
    }
  } else {
    return 0;
  }
}

function halfPageOffset() {
  if (document.body.contains(document.querySelector('.page-width'))) {
    const container = document.querySelector('.page-width');
    const offset = container.offsetLeft;
    return offset;
  }
}

document.documentElement.style.setProperty(
  '--window-height',
  windowHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--header-height',
  headerHeight() + 'px'
);
document.documentElement.style.setProperty(
  '--half-page-offset',
  halfPageOffset() + 'px'
);
document.documentElement.style.setProperty(
  '--cart-footer-height',
  cartFooter() + 'px'
);
document.documentElement.style.setProperty(
  '--announcement-height',
  announcementHeight() + 'px'
);

window.addEventListener(
  'resize',
  debounce(function () {
    document.documentElement.style.setProperty(
      '--header-height',
      headerHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--window-height',
      windowHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--cart-footer-height',
      cartFooter() + 'px'
    );
    document.documentElement.style.setProperty(
      '--announcement-height',
      announcementHeight() + 'px'
    );
    document.documentElement.style.setProperty(
      '--half-page-offset',
      halfPageOffset() + 'px'
    );
  }, 50)
);

const siteHeader = document.querySelector('[data-site-header]');

if (siteHeader) {
  function setHeader(headerHeight) {
    document.querySelector('body').style['padding-top'] = `${headerHeight}px`;
    siteHeader.classList.add('fixed');
  }

  /*
  function fixHeader() {
    const stickyOffset = siteHeader.offsetHeight;
    const scroll = window.scrollY;

    if (scroll > stickyOffset) {
      if (!siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.add('scrolling');
        siteHeader.classList.add('fixed');
      }
    } else {
      if (siteHeader.classList.contains('scrolling', 'fixed')) {
        siteHeader.classList.remove('scrolling');
        siteHeader.classList.remove('fixed');
      }
    }
  }

  window.addEventListener(
    'touchmove',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'scroll',
    debounce(function () {
      fixHeader();
    }, 50)
  );

  window.addEventListener(
    'resize',
    debounce(function () {
      fixHeader();
    }, 50)
  );
*/
  window.addEventListener('load', (event) => {
    setHeader(headerHeight());
  });
}

/************ Smooth Scroll  ****************/

document.addEventListener('click', function (e) {
  const anchor = e.target.closest(
    'a[href*="#"]:not([href="#"], .no-scroll, [data-toggle-target])'
  );
  if (!anchor) return;

  e.preventDefault();
  console.log('scroll to ', anchor.href);

  const offset = headerHeight() * -2;
  if (
    location.pathname.replace(/^\//, '') ===
      anchor.pathname.replace(/^\//, '') &&
    location.hostname === anchor.hostname
  ) {
    let target = anchor.hash;
    target = target.length
      ? target
      : document.querySelector(`[name="${anchor.hash.slice(1)}"]`);

    if (target) {
      const element = document.getElementById(target.replace('#', ''));
      console.log('element', element);

      if (element) {
        window.scrollTo({
          top: getOffsetTop(element) + offset,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }
});

function getOffsetTop(element) {
  return element ? element.offsetTop + getOffsetTop(element.offsetParent) : 0;
}

// URL PARAMETERS

function getUrlParameter(param) {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(param);
  return value !== null ? decodeURIComponent(value) : null;
}
function getUrlHash(uHash) {
  const hash = window.location.hash.substring(1); // Remove the '#' symbol
  return hash === uHash;
}

// RANGE SLIDERS

function createRangeSliders() {
  let rangeMin = 0;
  document.querySelectorAll('[data-range-container]').forEach((ranger) => {
    //console.log(ranger, 'ranger');
    const rangeInput = ranger.querySelectorAll('[data-range-slider] input');
    const rangePrice = ranger.querySelectorAll('[data-range-prices] input');
    const range = ranger.querySelector('[data-range-selected]');
    // console.log('range', range);
    function getPosition(rangeInput, rangePrice, range) {
      let minRange = parseInt(rangeInput[0].value);
      let maxRange = parseInt(rangeInput[1].value);
      if (maxRange - minRange < rangeMin) {
        if (e.target.className === 'min') {
          rangeInput[0].value = maxRange - rangeMin;
        } else {
          rangeInput[1].value = minRange + rangeMin;
        }
      } else {
        rangePrice[0].value = minRange;
        rangePrice[1].value = maxRange;
        range.style.left = (minRange / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxRange / rangeInput[1].max) * 100 + '%';
      }
    }
    rangeInput.forEach((input) => {
      getPosition(rangeInput, rangePrice, range);
      input.addEventListener('input', () => {
        getPosition(rangeInput, rangePrice, range);
      });
    });

    rangePrice.forEach((input) => {
      input.addEventListener('input', (e) => {
        let minPrice = rangePrice[0].value;
        let maxPrice = rangePrice[1].value;
        if (maxPrice - minPrice >= rangeMin && maxPrice <= rangeInput[1].max) {
          if (e.target.className === 'min') {
            rangeInput[0].value = minPrice;
            range.style.left = (minPrice / rangeInput[0].max) * 100 + '%';
          } else {
            rangeInput[1].value = maxPrice;
            range.style.right =
              100 - (maxPrice / rangeInput[1].max) * 100 + '%';
          }
        }
      });
    });
  });
}

// Event Tracking
document.addEventListener('click', function (e) {
  const target = e.target.closest('[data-etrack]');
  if (!target) return; // ignore clicks outside tracked elements

  e.preventDefault();

  const eventName = target.dataset.etrack || 'element_click';
  const href = target.getAttribute('href');

  // Send event to GA4
  if (typeof gtag === 'function') {
    gtag('event', eventName, {
      event_category: 'interaction',
      event_label: href || target.outerHTML,
    });
  }

  // If element has an href, open in new tab
  if (href) {
    //console.log('go to event link');
    window.open(href, '_blank');
  }
});
// MEGA MENU REVISION

// Helper: Get cache from sessionStorage (Survives page navigations!)
function getCachedMenu(sectionId) {
  const cached = sessionStorage.getItem(`megaMenu_${sectionId}`);
  return cached || null;
}

// Helper: Save cache to sessionStorage
function setCachedMenu(sectionId, html) {
  try {
    sessionStorage.setItem(`megaMenu_${sectionId}`, html);
  } catch (e) {
    console.error("Session storage full, cannot cache menu.", e);
  }
}

document.addEventListener('click', async (event) => {
  const summary = event.target.closest('.mega-nav-toggle');
  if (!summary) return;

  const sectionId = summary.dataset.section;
  const menuName = summary.dataset.menuName; 
  if (!sectionId || !menuName) return;

  const details = summary.closest('details');

  // Prevent double loading or firing while already loading
  if (details.dataset.loaded === 'true' || details.dataset.loading === 'true') return;
  
  // Lock the toggle so rapid clicks don't trigger multiple fetches
  details.dataset.loading = 'true';

  // Helper function to inject the panel from an HTML string
  function injectPanel(htmlString) {
    const temp = document.createElement('div');
    temp.innerHTML = htmlString;
    
    const panel = temp.querySelector(`[data-name="${menuName}"]`);
    if (panel) {
      // Remove loading placeholder if it exists
      const loading = details.querySelector('.mega-loading');
      if (loading) loading.remove();
      
      summary.insertAdjacentElement('afterend', panel.cloneNode(true));
      details.dataset.loaded = 'true';
      delete details.dataset.loading;
      return true;
    }
    return false;
  }

  // 1. Check Session Cache first (Instant if available)
  const cachedHTML = getCachedMenu(sectionId);
  if (cachedHTML) {
    if (injectPanel(cachedHTML)) return; // Stop here if we successfully injected
  }

  // 2. Show Loading Placeholder (Only if we didn't have it cached)
  summary.insertAdjacentHTML('afterend', `<div class="mega-loading"><div class="with-icon"><div class="loading__spinner"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></div> Loading…</div></div>`);

  // 3. Fetch section HTML from Shopify
  const url = `/?section_id=${sectionId}`;
  try {
    const response = await fetch(url);
    const html = await response.text();

    // Save to session cache for next time
    setCachedMenu(sectionId, html);

    // Inject the panel
    injectPanel(html);
  } catch (error) {
    console.error("Failed to load mega menu:", error);
    const loading = details.querySelector('.mega-loading');
    if (loading) loading.remove();
    delete details.dataset.loading;
  }
});

// Prefetch on hover for instant first-click
document.addEventListener('mouseover', (event) => {
  const summary = event.target.closest('.mega-nav-toggle');
  if (!summary) return;

  const sectionId = summary.dataset.section;
  if (!sectionId || getCachedMenu(sectionId)) return; // Don't fetch if already cached

  // Fetch quietly in the background and cache it
  fetch(`/?section_id=${sectionId}`)
    .then(r => r.text())
    .then(html => setCachedMenu(sectionId, html))
    .catch(() => {});
});